import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('attributes', storeModule.createStoreModule('attributes'))
